import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from '../../../../../components/Tooltip';

const BalanceCell = ({ element, item }) => {
  let content = null;

  if (element?.value?.balance) {
    content = (
      <>
        {element.value?.balance}
        {' '}
        {element.value?.currency}
      </>
    );
  } else if (!item?.balance_is_available) {
    if (item?.fetch_balance) {
      content = (
        <span className="fa fa-spinner fa-spin" style={{ fontSize: '18px' }} />
      );
    } else {
      content = (
        <Tooltip placement="top" tooltipClass="tooltip__top" text="Balance info not available for that provider">
          <span className="fas fa-info-circle" />
        </Tooltip>
      );
    }
  } else {
    content = '';
  }

  return <td>{content}</td>;
};

BalanceCell.propTypes = {
  element: PropTypes.object,
  item: PropTypes.object,
};

export default BalanceCell;
